import { ReactElement } from 'react'
import { messages } from '../../../utils/messages'
import { Box, List, ListItem } from '@mui/material'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { thopNotificationAlertType } from '../../../utils/constants'
import useGetPatientDetails from '../../../utils/useGetPatientDetails'
import {
  setPatientUHID,
  setCurrentLocation,
  setSelectedPatientIndex,
  deleteThopNotificationMessage,
} from '../../../redux/actions'
import './ThopNotifications.css'

interface NotificationItemProps {
  setOpen: (open: boolean) => void
}

const NotificationItem = ({ setOpen }: NotificationItemProps): ReactElement => {
  const dispatch = useDispatch()
  const { fetchPatientDetails } = useGetPatientDetails()
  const notificationMessages = useSelector(
    (state: any) => state?.thopNotificationMessages
  )
  const patientDetails = useSelector(
    (state: any) => ({
      masterPatientDetails: state?.masterPatientDetails,
    }),
    shallowEqual
  )

  const getValidClass = (patient: any) => {
    return patient?.messageType === thopNotificationAlertType?.acceptCareplan
      ? thopNotificationAlertType?.statusAccepted
      : thopNotificationAlertType?.statusRejected
  }

  const handleAlertItemClick = (
    e: React.MouseEvent,
    index: number,
    muhid: string,
    location: string
  ) => {
    // Close the drawer when a notification is clicked
    setOpen(false)

    const patientsList = patientDetails?.masterPatientDetails?.find(
      (subArray: { patientId: string }[]) =>
        subArray?.some(
          (patient: { patientId: string }) => patient?.patientId === muhid
        )
    )
    const patientExists = patientDetails?.masterPatientDetails
      ?.flat()
      ?.some((patient: { patientId: string }) => patient?.patientId === muhid)

    if (patientExists) {
      const patientIndex = patientsList?.findIndex(
        (item: { patientId: string }) => item?.patientId === muhid
      )
      fetchPatientDetails(muhid)
      dispatch(setPatientUHID(muhid))
      dispatch(setCurrentLocation(location))
      dispatch(setSelectedPatientIndex(patientIndex))
    } else {
      alert(messages?.patientDetailsNotFound)
    }

    // Finally remove the notification from the list
    removeNotification(e, index)
  }

  const removeNotification = (e: React.MouseEvent, index: number) => {
    e.stopPropagation()
    dispatch(deleteThopNotificationMessage(index))
  }

  return (
    <Box
      id='drawer-list-container'
      onClick={() => setOpen(false)}
      onKeyDown={() => setOpen(false)}
      className='notification-list-item-container'
    >
      <List>
        {notificationMessages?.map((patient, index) => (
          <ListItem
            disablePadding
            id={crypto.randomUUID()}
            key={patient?.patientID}
            className='notification-list-item'
          >
            <Box
              onClick={(event) => {
                handleAlertItemClick(
                  event,
                  index,
                  patient?.patientID,
                  patient?.patientLocation
                )
              }}
              className='notificationItem'
            >
              <p className='patientInfo'>
                {patient?.patientID}&nbsp;-&nbsp;{patient?.patientLocation}
              </p>
              <p className={getValidClass(patient)}>{patient?.message}</p>
              {patient?.messageType ===
                thopNotificationAlertType?.rejectCareplan && (
                <p className='rejectionReason'>{patient?.reason}</p>
              )}
            </Box>
          </ListItem>
        ))}
      </List>
    </Box>
  )
}

export default NotificationItem
